import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, Input, InputNumber, message, Popconfirm } from "antd";
import { store } from '../../../app/store';
import { ServicesConfig } from "../../../service/servicesConfig";

const MapLayerManager = () => {
  const [mapLayers, setMapLayers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingMapLayer, setEditingMapLayer] = useState(null);
  const [form] = Form.useForm();

  const baseURL = ServicesConfig.getBaseUrlV2()  + "/admin/map_layer"; // Base URL para SGVMAP_MAP_LAYERController

  
  const getAuthorization = () => {
    const state = store.getState();
    return state.user.logged ? "Bearer " + state.user.token : ""
  }
  
  // Obtener todas las capas de mapa
  const fetchMapLayers = async () => {
    try {
      const response = await fetch(`${baseURL}/list`, {
        headers: { Authorization: getAuthorization() },
      }); // Asume un endpoint para listar todas las capas de mapa
      if (!response.ok) throw new Error("Error al obtener las capas de mapa");
      const data = await response.json();
      setMapLayers(data);
    } catch (error) {
      message.error("Error al obtener la lista de capas de mapa");
      console.error(error);
    }
  };

  // Crear o actualizar una capa de mapa
  const handleSaveMapLayer = async (values) => {
    const method = editingMapLayer ? "PUT" : "POST";
    const url = editingMapLayer
      ? `${baseURL}/update`
      : `${baseURL}/create`;

    try {
      const response = await fetch(url, {
        method: method,
        headers: { 
          "Content-Type": "application/json",
          Authorization: getAuthorization()
        },
        body: JSON.stringify(values),
      });
      if (!response.ok) throw new Error("Error al guardar la capa de mapa");

      message.success(
        editingMapLayer
          ? "Capa de mapa actualizada correctamente"
          : "Capa de mapa creada correctamente"
      );
      fetchMapLayers();
      setIsModalOpen(false);
      setEditingMapLayer(null);
      form.resetFields();
    } catch (error) {
      message.error("Error al guardar la capa de mapa");
      console.error(error);
    }
  };

  // Eliminar una capa de mapa
  const handleDeleteMapLayer = async (idMapLayer) => {
    try {
      const response = await fetch(`${baseURL}/delete/${idMapLayer}`, {
        method: "DELETE",
        headers: { Authorization: getAuthorization() },
      });
      if (!response.ok) throw new Error("Error al eliminar la capa de mapa");

      message.success("Capa de mapa eliminada correctamente");
      fetchMapLayers();
    } catch (error) {
      message.error("Error al eliminar la capa de mapa");
      console.error(error);
    }
  };

  // Abrir modal para edición
  const handleEdit = (mapLayer) => {
    setEditingMapLayer(mapLayer);
    form.setFieldsValue(mapLayer);
    setIsModalOpen(true);
  };

  // Abrir modal para creación
  const handleCreate = () => {
    setEditingMapLayer(null);
    form.resetFields();
    setIsModalOpen(true);
  };

  useEffect(() => {
    fetchMapLayers();
  }, []);

  const columns = [
    {
      title: "ID Capa de Mapa",
      dataIndex: "idMapLayer",
      key: "idMapLayer",
    },
    {
      title: "Tipo",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Descripción",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Acciones",
      key: "actions",
      render: (text, record) => (
        <>
          <Button type="link" onClick={() => handleEdit(record)}>
            Editar
          </Button>
          <Popconfirm
            title="¿Estás seguro de eliminar esta capa de mapa?"
            onConfirm={() => handleDeleteMapLayer(record.idMapLayer)}
            okText="Sí"
            cancelText="No"
          >
            <Button type="link" danger>
              Eliminar
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <h1>Gestión de Capas de Mapa</h1>
      <Button type="primary" onClick={handleCreate} style={{ marginBottom: 16 }}>
        Crear Capa de Mapa
      </Button>
      <Table
        columns={columns}
        dataSource={mapLayers}
        rowKey="idMapLayer"
      />

      <Modal
        title={editingMapLayer ? "Editar Capa de Mapa" : "Crear Capa de Mapa"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => form.submit()}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSaveMapLayer}
          initialValues={{ type: "", name: "", description: "" }}
        >

           <Form.Item
            name="idMapLayer"
            label="ID Capa de Mapa"
            rules={[{ required: true, message: "Por favor, ingrese ID Capa de Mapa" }]}
          >
            <Input placeholder="ID Capa de Mapa" />
          </Form.Item>

          <Form.Item
            name="type"
            label="Tipo"
            rules={[{ required: true, message: "Por favor, ingrese el tipo" }]}
          >
            <Input placeholder="Tipo de la Capa de Mapa" />
          </Form.Item>
          <Form.Item
            name="name"
            label="Nombre"
            rules={[{ required: true, message: "Por favor, ingrese el nombre" }]}
          >
            <Input placeholder="Nombre de la Capa de Mapa" />
          </Form.Item>
          <Form.Item
            name="description"
            label="Descripción"
          >
            <Input placeholder="Descripción de la Capa de Mapa" />
          </Form.Item>

          <Form.Item
            name="config"
            label="Configuración"
            rules={[{ required: false }]}
          >
            <Input.TextArea placeholder="Configuración (opcional)" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default MapLayerManager;
